import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Base64 } from 'js-base64';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Context } from '../controls/advanced-gridview/models/context';
import { FilterInfos } from '../controls/advanced-gridview/models/filter-infos';
import { Results } from '../controls/advanced-gridview/models/results-T';
import { SortInfos } from '../controls/advanced-gridview/models/sort-infos';
import { LogSupervisionEntry } from '../models/log-supervision-entry';
import { MemoryService } from './memory.service';
import { CrudService } from './crud-service';

@Injectable({
    providedIn: 'root',
})
export class LogSupervisionService extends CrudService {
    constructor(
        private http: HttpClient,
        public override memoryService: MemoryService
    ) {
        super(memoryService);
    }

    /**
     * Liste les listLayout
     */
    List(context: Context, filters: FilterInfos[], generalFilters: FilterInfos[], sortInfos: SortInfos, pageNumber = 0, pageSize = 100): Observable<Results<LogSupervisionEntry>> {
        let params = new Map<string, string | number | boolean>();
        params.set('from', pageNumber);
        params.set('size', pageSize);

        const httpOptions = this.getListHttpOptions(context, filters, generalFilters, sortInfos, params);

        // Appel de la Web Api
        return this.http.get(this.baseUrl + `/api/logs-supervision`, httpOptions).pipe(
            map((x) => {
                var res = Results.getCopyFrom<LogSupervisionEntry>(LogSupervisionEntry, x);

                return res;
            })
        );
    }

    Export(context: Context, filters: FilterInfos[], generalFilters: FilterInfos[], sortInfos: SortInfos) {
        const headers = this.getExportHeader(context, filters, generalFilters, sortInfos);

        // Appel de la Web Api
        return this.http.get(this.baseUrl + `/api/logs-supervision/export`, { headers: headers, responseType: 'blob' }).pipe(
            map((res: any) => {
                const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                return blob;
            })
        );
    }
}
